import { getSettingRetailerExclusivityAgreements } from "@faire/help-center-utils/settings/getSettingRetailerExclusivityAgreements";
import { ViewInvoicesCTA } from "./ctas";
export var BulkDownloadIA = function BulkDownloadIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BULK_DOWNLOAD_INVOICES(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [HOW_TO_BULK_DOWNLOAD_INVOICES(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return ViewInvoicesCTA(strictLocalize);
};
var BULK_DOWNLOAD_INVOICES = function BULK_DOWNLOAD_INVOICES(strictLocalize) {
  if (getSettingRetailerExclusivityAgreements()) {
    return strictLocalize({
      id: "yD8gfS",
      defaultMessage: [{
        "type": 0,
        "value": "Download invoices"
      }]
    });
  }
  return strictLocalize({
    id: "8iEo3t",
    defaultMessage: [{
      "type": 0,
      "value": "Bulk-download invoices"
    }]
  });
};
var HOW_TO_BULK_DOWNLOAD_INVOICES = function HOW_TO_BULK_DOWNLOAD_INVOICES(strictLocalize) {
  return strictLocalize({
    id: "KeUqmc",
    defaultMessage: [{
      "type": 0,
      "value": "You can download your invoices in bulk by selecting the tick boxes next to the invoices and then clicking on the Download invoices button at the top of the Invoices page."
    }]
  });
};